<section id="clientMessage">
</section>
<section class="hero" (window:resize)="onResize($event)">
    <div class="hero-inner">
        <div class="container">
            <div class="row">
                <div class="col-xs-12" style="margin-left: auto; margin-right: auto; text-align: center">
                    <div style="margin-left: auto; margin-right: auto; text-align: center">
                        <div class="hero-logo" style="margin-top: 13vh;"><img src="./assets/cls-sphere.jpg"
                                alt="CLS Logo" width="80" /></div>
                        <div style="display: flex;">
                            <div style="margin-top: 30px;">
                                <h1 class="title section-title hero-title">Welcome to <br /><span
                                        style=" color: #3c7abf">CLS Property Insight</span></h1>
                                <p class="hero-subtitle" style="max-width: 620px;">Search and Legal Indemnity solutions
                                    for property professionals all at the touch of a button. An innovative online system
                                    smoothing your transactions, aiding due diligence and managing risk; supported by
                                    personal and unique
                                    expert advice and assistance from the highly qualified underwriters and customer
                                    service teams.</p><br /><button class="cls-btn pi-primary" type="button"
                                    (click)="scroll('usp')">WHY US?</button><button class="cls-btn hero-primary-outline"
                                    type="button" style="margin-left: 15px" routerLink="/ordering/register">SIGN UP
                                    FREE</button>
                            </div>
                        </div>
                        <div class="overl-res d-none d-md-block"><img class="fadeOverlay" id="overlay"
                                src="./assets/CLS-PI/Property-Insight-Overlay.png"
                                style="position: absolute; bottom: 60px; right: 0; height: 30vh; width: 100vw;" /></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="infographics-section" id="usp"
    style="margin-top: 0px;padding-top: 60px; margin-bottom: 30px;background: #ffffff; background-image: -webkit-linear-gradient(top, #e7e9e9 25%, #ffffff 100%);">
    <div class="container-fluid">
        <div class="row" style="text-align: center; color: #3d4d62; margin-left: auto; margin-right: auto;">
            <div class="col-12">
                <h1 class="section-title" style="margin-bottom: 50px; margin-top:30px;">Where We<span
                        style="color: #3c7abf"> Shine</span></h1>
            </div>
        </div>
        <div class="row"
            style="text-align: center; color: #3d4d62; margin-left: auto; margin-right: auto; margin-bottom: 70px; max-width:1250px;">
            <!--1-->
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4" style="padding-top: 25px; padding-bottom: 25px;"><img
                    src="./assets/CLS-PI/usp/Group 1437@2x.png" width="256" /></div>
            <!--2-->
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4"
                style="padding-top: 25px; padding-bottom: 25px; text-align: center; margin-left: auto; margin-right: auto">
                <img src="./assets/CLS-PI/usp/Group 1331@2x.png" width="202" /></div>
            <!--3-->
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4"
                style="padding-top: 25px; padding-bottom: 25px;text-align: center;"><img
                    src="./assets/CLS-PI/usp/Group 1426@2x.png" width="162" height="130" /></div>
            <!--4-->
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4" style="padding-top: 25px; padding-bottom: 25px;"><img
                    src="./assets/CLS-PI/usp/Group 1328@2x.png" width="232" /></div>
            <!--5-->
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4" style="padding-top: 25px; padding-bottom: 25px;"><img
                    src="./assets/CLS-PI/usp/Group 1433@2x.png" width="264" /></div>
            <!--6-->
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4" style="padding-top: 25px; padding-bottom: 25px;"><img
                    src="./assets/CLS-PI/usp/Group 1440@2x.png" width="184" /></div>
        </div>
    </div>
</section>
<section style="padding-top: 60px; min-height: 500px; background: #EDEFF2; padding-bottom: 80px">
    <div style="text-align: center;">
        <h1 style="position: relative; top: 20px;">Products and<span style="color: #3c7abf"> Services</span></h1>
    </div>
    <div class="container">
        <div class="container"></div>
        <!-- tab selectors | tablet-->
        <div class="row text-center selectors">
            <div class="col-12" style="margin-bottom: 0;">
                <ul class="nav nav-tabs" style="margin-top: 60px; margin-left: auto; margin-right: auto">
                    <li class="nav-item" style="margin-left: auto; margin-right: auto"> <a class="nav-link"
                            (click)="selectedSlice=0" [ngClass]="selectedSlice==0?'activeTab-link':''">Chancel</a></li>
                    <li class="nav-item" style="margin-left: auto; margin-right: auto"> <a class="nav-link"
                            (click)="selectedSlice=1" [ngClass]="selectedSlice==1?'activeTab-link':''">Environmental</a>
                    </li>
                    <li class="nav-item" style="margin-left: auto; margin-right: auto"> <a class="nav-link"
                            (click)="selectedSlice=2" [ngClass]="selectedSlice==2?'activeTab-link':''">Ancillary</a>
                    </li>
                    <li class="nav-item" style="margin-left: auto; margin-right: auto"> <a class="nav-link"
                            (click)="selectedSlice=3" [ngClass]="selectedSlice==3?'activeTab-link':''">Land Registry</a>
                    </li>
                    <li class="nav-item" style="margin-left: auto; margin-right: auto"> <a class="nav-link"
                            (click)="selectedSlice=4" [ngClass]="selectedSlice==4?'activeTab-link':''">Surveys</a></li>
                    <li class="nav-item" style="margin-left: auto; margin-right: auto"> <a class="nav-link"
                            (click)="selectedSlice=5" [ngClass]="selectedSlice==5?'activeTab-link':''">Indemnity</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="row text-center small-selectors" style="padding-top: 60px;">
            <div class="div col-2"><button class="btn btn-circle primary-outline"
                    [ngClass]="{'btn-circle-selected':selectedSlice==0}" (click)="selectedSlice=0"></button></div>
            <div class="div col-2"><button class="btn btn-circle primary-outline"
                    [ngClass]="{'btn-circle-selected':selectedSlice==1}" (click)="selectedSlice=1"></button></div>
            <div class="div col-2"><button class="btn btn-circle primary-outline"
                    [ngClass]="{'btn-circle-selected':selectedSlice==2}" (click)="selectedSlice=2"></button></div>
            <div class="div col-2"><button class="btn btn-circle primary-outline"
                    [ngClass]="{'btn-circle-selected':selectedSlice==3}" (click)="selectedSlice=3"></button></div>
            <div class="div col-2"><button class="btn btn-circle primary-outline"
                    [ngClass]="{'btn-circle-selected':selectedSlice==4}" (click)="selectedSlice=4"></button></div>
            <div class="div col-2"><button class="btn btn-circle primary-outline"
                    [ngClass]="{'btn-circle-selected':selectedSlice==5}" (click)="selectedSlice=5"></button></div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-md-12 piecolumn">
                <div style="position: relative"><img src="../../../assets/cls-logo-sphere.png" alt="CLS logo" width="80"
                        style="position: absolute; top: 237px; left: 230px;" /></div>
                <div id="piechart" style="width: 100%; height:100%; width: 540px; height: 684px;"></div>
            </div>
            <div class="col-lg-6 col-md-12 descriptioncolumn">
                <div style="margin-top: 60px;">
                    <div *ngIf="selectedSlice==0">
                        <h5> <strong>Chancel Searches </strong></h5>
                        <p style="font-size: 16px; color: #6B7072">Chancel repair liability is a medieval anomaly that
                            granted Parish Churches powers to charge landowners for the upkeep of the chancel of the
                            church. It is just as relevant to conveyancers today as when originally granted.</p>
                        <p style="font-size: 14px; color: #6B7072; margin-bottom: 0;"><strong>ChancelCheck<span
                                    style="font-size: 22px;">&reg;</span></strong></p>
                        <p style="font-size: 14px; color: #6B7072">ChancelCheck<span
                                style="font-size: 22px;">&reg;</span> is a unique, instant, low cost screening report
                            designed to identify parishes where there is a continuing potential to charge for repairs to
                            the parish church chancel.
                        </p>
                        <p style="font-size: 14px; color: #6B7072; margin-bottom: 6px"> <strong>Note: </strong> Where a
                            property is affected, conveyancers who have failed to screen for this risk may be deemed
                            negligent. </p><a href="./assets/product-cards/Chancel Check_Colour Footer.pdf"
                            target="_blank" style="font-size: 14px"><img src="./assets/download-product-card.png"
                                width="16" style="margin-right: 8px; position: relative; bottom: 1px" />Download Product
                            Sheet</a>
                        <p style="font-size: 14px; color: #6B7072; margin-bottom: 0; margin-top: 16px">
                            <strong>ChancelCheck<span style="font-size: 22px;">&reg;</span>Premium</strong></p>
                        <p style="font-size: 14px; color: #6B7072; margin-bottom: 6px">ChancelCheck<span
                                style="font-size: 22px;">&reg;</span> Premium is a unique, online, low cost screening
                            report designed to analyse a large area of land to identify where there is a potential to
                            charge for repairs to the
                            parish church chancel. </p><a
                            href="./assets/product-cards/Chancel Check Premium_Colour Footer.pdf" target="_blank"
                            style="font-size: 14px; margin-bottom: 10px"><img src="./assets/download-product-card.png"
                                width="16" style="margin-right: 8px; position: relative; bottom: 1px" />Download Product
                            Sheet</a>
                        <p style="font-size: 14px; color: #6B7072; margin-bottom: 0; margin-top: 16px">
                            <strong>ChancelCheck<span style="font-size: 22px;">&reg;</span> and TitleChecker</strong>
                        </p>
                        <p style="font-size: 14px; color: #6B7072; margin-bottom: 6px;">Combining with the
                            ChancelCheck<span style="font-size: 22px;">&reg;</span> product, the TitleChecker
                            automatically examines Land Registry records to provide a report on title, reducing the time
                            and cost needed to complete
                            the interrogation.</p><a href="./assets/product-cards/TitleChecker_Colour Footer.pdf"
                            target="_blank" style="font-size: 14px;"><img src="./assets/download-product-card.png"
                                width="16" style="margin-right: 8px; position: relative; bottom: 1px" />Download Product
                            Sheet</a>
                        <p style="font-size: 14px; color: #6B7072; padding-top: 16px; margin-bottom: 6px;">
                            <strong>ChancelSure Insurance</strong></p>
                        <p style="font-size: 14px; color: #6B7072;">Following receipt of a Report to highlight that the
                            property area or land selected falls within a parish or parishes having the ability to claim
                            for chancel repair liability, our ChancelSure insurance is available
                            to offer protection over chancel repair claims.</p>
                        <div><a href="./assets/product-cards/ChancelSure_Colour Footer.pdf" target="_blank"
                                style="font-size: 14px; margin-right: 30px"><img
                                    src="./assets/download-product-card.png" width="16"
                                    style="margin-right: 8px; position: relative; bottom: 1px" /> Download Product
                                Sheet</a>
                            <a href="./assets/product-cards/ChancelSure Case Study.pdf" target="_blank"
                                style="font-size: 14px;"><i class="fa fa-file"
                                    style="margin-right: 8px; position: relative; top: 1px; color: #3077FF"></i> Case
                                Study</a>
                        </div>
                    </div>
                    <div *ngIf="selectedSlice==1">
                        <h5> <strong>Environmental Searches </strong></h5>
                        <p style="font-size: 14px; color: #6B7072;"> <strong>Environmental Reports by Future Climate
                                Info</strong></p>
                        <p style="font-size: 14px; color: #6B7072;">An innovative suite of Environmental Reports that
                            analyses data on Contaminated Land, Flood, Ground Stability and Energy &amp; Infrastructure.
                            The reports are divided into Premium, Standard and Essential with standardised data
                            modules to ensure that each element provides a consistent response for each report.  FCI is
                            the only RICS accredited supplier of environmental reports which are also Law Society
                            guidance compliant.</p><br />
                        <p style="font-size: 14px; color: #6B7072;">
                            <strong>FCI-JBA Specialist Flood Risk Report Review</strong></p>
                        <p style="font-size: 14px; color: #6B7072;">FCI-JBA Specialist Flood Risk Services provide peace
                            of mind should an FCI report identify a further action on flood, offering a range of
                            different next-step solutions for purchasers or owners of residential or commercial
                            properties.</p><br />
                        <p style="font-size: 14px; color: #6B7072;"> <strong>Ashfield D-Risk Flood</strong></p>
                        <p style="font-size: 14px; color: #6B7072;">Ashfield Flood Risk Solutions understands the issues
                            caused by flood affected land. This report focuses on unlocking flood impacted areas to
                            enable the client to realise the full potential value for a site.</p><br />
                        <p style="font-size: 14px; color: #6B7072;">
                            <strong>CON29M Coal Mining Report </strong></p>
                        <p style="font-size: 14px; color: #6B7072;">Our CON29M is the only official, coal mining
                            related, Law Society approved conveyancing product. It identifies and interprets coal mining
                            risks for clients purchasing residential properties.</p><br />
                    </div>
                    <div *ngIf="selectedSlice==2">
                        <h5> <strong>Ancillary Searches </strong></h5>
                        <p style="font-size: 14px; color: #6B7072;">We have substantial number of ancillary searches
                            available to add to your favourites and packs, making a complete order solution.</p>
                        <ol>
                            <li style="font-size: 14px; color: #6B7072;">Clay Search</li>
                            <li style="font-size: 14px; color: #6B7072;">Limestone Search </li>
                            <li style="font-size: 14px; color: #6B7072;">Official Drainage and Water search (Commercial)
                                UK) </li>
                            <li style="font-size: 14px; color: #6B7072;">Official Drainage and Water search
                                (Residential) UK)</li>
                            <li style="font-size: 14px; color: #6B7072;">Regulated Drainage and Water search
                                (Residential) UK) </li>
                            <li style="font-size: 14px; color: #6B7072;">Regulated Local Authority (UK) (235) </li>
                            <li style="font-size: 14px; color: #6B7072;">Tin and Metal Minerals Search </li>
                        </ol>
                    </div>
                    <div *ngIf="selectedSlice==3">
                        <h5> <strong>Land Registry </strong></h5>
                        <p style="font-size: 14px; color: #6B7072;">Through our partnership and integration with Land
                            Registry we offer common Land Registry services and submissions.</p>
                        <ol>
                            <li style="font-size: 14px; color: #6B7072;">Daylist Enquiry </li>
                            <li style="font-size: 14px; color: #6B7072;">Documents referred to in the Official Copy 
                            </li>
                            <li style="font-size: 14px; color: #6B7072;">Filed Plan View </li>
                            <li style="font-size: 14px; color: #6B7072;">Land Charges Bankruptcy Search </li>
                            <li style="font-size: 14px; color: #6B7072;">Official Search with Priority </li>
                            <li style="font-size: 14px; color: #6B7072;">Register of Title </li>
                            <li style="font-size: 14px; color: #6B7072;">TitleChecker </li>
                            <li style="font-size: 14px; color: #6B7072;">TitleChecker Refresher </li>
                        </ol>
                    </div>
                    <div *ngIf="selectedSlice==4">
                        <h5> <strong>Surveys</strong></h5>
                        <p style="font-size: 14px; color: #6B7072;">Advice on the condition and/or value of a property
                            in accordance with the Royal Institution of Chartered Surveyors (RICS), provided by one of
                            the UK’s leading surveying companies, Countrywide Surveying Services.</p>
                        <p style="font-size: 14px; color: #6B7072;">Acting on behalf of the property purchaser,
                            Countrywide Surveying Services provide a selection of different surveys to suit the varying
                            needs of different properties and purchasers.  These include a Property Valuation, RICS
                            Homebuyer
                            Report, or a Building Survey for older or more unusual properties.</p>
                        <p style="font-size: 14px; color: #6B7072;">Developed with the homebuyers and their conveyancers
                            in mind, the survey will identify any visible internal and external problems that need
                            further investigation, with the results provided as a clear and concise report on the
                            condition
                            of the property. This report allows the client to make an informed decision prior to
                            purchase and may save the cost of a lender valuation if they decide not to proceed. 
                            According to a WHICH? Report, consumers who have their
                            property surveyed save an average of £2,000 on the property price.</p>
                    </div>
                    <div *ngIf="selectedSlice==5">
                        <h5> <strong>Legal Indemnity Insurance</strong></h5>
                        <p style="font-size: 14px; color: #6B7072;">CLS offer market leading Legal Indemnity Insurance
                            products available for both residential and commercial property transactions. Our online
                            suite of products offers over 60 types of policies, ranging from Lack of Building
                            Regulations
                            and Defective Lease to Forfeiture of Lease (Housing Act) and Contaminated Land Indemnities.
                            Our immediate cover is designed to protect lenders, property owners and/or developers
                            against third party claims arising from problems
                            affecting the title, use or development of land. For transactions where you cannot comply
                            with the "Statements of Fact" online, we have a dedicated specialist underwriting team
                            offline who are available to assist by providing
                            you with a bespoke offline policy. We focus on delivering solutions that mitigate risk, in
                            the most cost effective way possible. Contact express@clspropertyinsight.co.uk.</p>
                        <p style="font-size: 14px; color: #6B7072;">CLS’ insurance is underwritten by an AA- (S&P) rated insurance capacity, giving your clients access to one of the highest rated security available in the UK property market.</p>
                    </div>
                    <div style="margin-top: 10px"><br />
                        <div style="display: inline"><img src="../../../assets/members/clientservices-team.png"
                                width="170"
                                style="vertical-align: top; border: 6px solid #024693; border-radius: 100px" /></div>
                        <div style="display: inline-block; margin-left: 25px;">
                            <p style="padding-top: 15px; font-size: 14px; color: #6B7072">Contact: Client Services</p><a
                                href="mailto:info@clspropertyinsight.co.uk">info@clspropertyinsight.co.uk</a><br /><a
                                href="#">+44 (0) 1732 753 910</a><br />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div style="text-align: center; margin-top: 80px; margin-bottom: 0px">
                    <h1>Working <span style="color: #3c7abf">with</span></h1><br />
                </div>
                <div style="margin-top: 20px; margin-bottom: 100px; text-align: center;"><img class="os"
                        src="../../../assets/working-with-logos/OS.png" /><img class="landreg"
                        src="../../../assets/working-with-logos/landreg.png" /><img class="nrw"
                        src="../../../assets/working-with-logos/NRW.png" /><img class="jba"
                        src="../../../assets/working-with-logos/JBA.png" /><img class="wf"
                        src="../../../assets/working-with-logos/When.png" /><img class="ea"
                        src="../../../assets/working-with-logos/EA.png" /><img class="earthSense"
                        src="../../../assets/working-with-logos/EarthSense.png" width="126" /><img class="glise"
                        src="../../../assets/working-with-logos/GreatLakes.png" />
                        <img class="aviva" src="../../../assets/working-with-logos/Aviva.png" /></div>
            </div>
        </div>
    </div>
</section>
<section style="background: #f2f5f5; padding-bottom:50px;">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div style="text-align: center; margin-top: 80px">
                    <h1>Key<span style="color: #3c7abf"> Contacts</span></h1><br />
                </div>
                <team-carousel [members]="_teamMembers" [showControls]="true"
                    style="margin-left: auto; margin-right: auto; text-align: center;"></team-carousel>
            </div>
        </div>
    </div>
</section>
<section class="news" *ngIf="_news.length"
    style="padding-top: 100px; padding-bottom: 160px;background:#034EA2; background-image: -webkit-linear-gradient(#034EA2 0%, #022751 100%); min-height: 500px">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h1 style="padding-bottom: 60px; color: #fff">CLS PI News</h1>
            </div>
        </div>
    </div>
    <news [news_pool]="_news"></news>
</section>